export default __webpack_public_path__ + "static/media/inter-regular-webfont.fd648549.woff2";